import { Flex, Typography } from 'antd';
import { HEALTH_DATA_FIELDS } from 'constants/patients';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import HealthDetailsItem from './HealthDetailsItem';
import { DetailsBody, StyledCard } from './styled';

const { Title } = Typography;

// Patient shape the health-details view reads (from the appointment/patient
// snapshot). health_info is the jsonb blob the items render.
export type PatientHealthData = {
  id?: string | number | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  first_name?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  last_name?: any;
  avatar?: string | null;
  date_of_birth?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  languages?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gender?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  health_info?: Record<string, any> | null;
};

interface IProps {
  data: PatientHealthData;
}

const PatientHealthDetails: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <StyledCard>
      <Flex vertical>
        <Title level={5} style={{ marginBottom: 16 }}>
          {t('appointments_details.health_details')}
        </Title>
        <DetailsBody>
          {HEALTH_DATA_FIELDS.map(item => (
            <HealthDetailsItem
              key={item.stepKey}
              title={item.title}
              stepKey={item.stepKey}
              optionsKey={item.optionsKey}
              otherKey={item.otherKey}
              unitKey={item.unitKey}
              gender={item.gender}
              patientData={data}
            />
          ))}
        </DetailsBody>
      </Flex>
    </StyledCard>
  );
};

export default PatientHealthDetails;
